import { BaseService, Service } from "/@/cool";

@Service("cartoon")
class Cartoon extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["style"] = prefix + "style";
		this.permission["uploadUrl"] = prefix + "uploadUrl";
		this.permission["putModeling"] = prefix + "putModeling";
		this.permission["cartoonList"] = prefix + "cartoonList";
		this.permission["check"] = prefix + "check";
		this.permission["shapeList"] = prefix + "shapeList";
		this.permission["compositeImage"] = prefix + "compositeImage";
	}

	style(params: any) {
		return this.request({
			url: "/style",
			method: "POST",
			data: {
				...params
			}
		});
	}

	uploadUrl(params: any) {
		return this.request({
			url: "/uploadUrl",
			method: "POST",
			data: {
				...params
			}
		});
	}

	putModeling(params: any) {
		return this.request({
			url: "/putModeling",
			method: "POST",
			data: {
				...params
			}
		});
	}

	cartoonList(params: any) {
		return this.request({
			url: "/cartoonList",
			method: "POST",
			data: {
				...params
			}
		});
	}

  cartoonCheck(params: any) {
		return this.request({
			url: "/check",
			method: "POST",
			data: {
				...params
			}
		});
	}

	shapeList(params: any) {
		return this.request({
			url: "/shapeList",
			method: "POST",
			data: {
				...params
			}
		});
	}

	compositeImage(params: any) {
		return this.request({
			url: "/compositeImage",
			method: "POST",
			data: {
				...params
			}
		});
	}
}

export default Cartoon;
